"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FusionProvider = exports.FusionContext = void 0;
var React = __importStar(require("react"));
var types_1 = require("./types");
var initialState = {
    modals: [],
    dialogs: [],
    modalClassNames: undefined,
    dialogClassNames: undefined
};
function reducer(state, action) {
    switch (action.type) {
        case types_1.ActionType.ADD_MODAL:
            return Object.assign({}, state, {
                modals: __spreadArrays(state.modals, [action.payload])
            });
        case types_1.ActionType.REMOVE_MODAL:
            return Object.assign({}, state, {
                modals: state.modals.filter(function (modal) { return modal.id !== action.payload; })
            });
        case types_1.ActionType.ADD_DIALOG:
            return Object.assign({}, state, {
                dialogs: __spreadArrays(state.dialogs, [action.payload])
            });
        case types_1.ActionType.REMOVE_DIALOG:
            return Object.assign({}, state, {
                dialogs: state.dialogs.filter(function (dialog) { return dialog.id !== action.payload; })
            });
        default:
            return state;
    }
}
exports.FusionContext = React.createContext({});
exports.FusionProvider = function (_a) {
    var children = _a.children, modalClassNames = _a.modalClassNames, dialogClassNames = _a.dialogClassNames;
    initialState.modalClassNames = modalClassNames;
    initialState.dialogClassNames = dialogClassNames;
    var _b = React.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    return React.createElement(exports.FusionContext.Provider, { value: { state: state, dispatch: dispatch } }, children);
};
